/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CollectedServiceDetailDto } from '../../models/collected-service-detail-dto';
import { CollectedServiceInputDataDto } from '../../models/collected-service-input-data-dto';

export interface ApiCollectedServicePut$Plain$Params {
      body?: CollectedServiceInputDataDto
}

export function apiCollectedServicePut$Plain(http: HttpClient, rootUrl: string, params?: ApiCollectedServicePut$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<CollectedServiceDetailDto>> {
  const rb = new RequestBuilder(rootUrl, apiCollectedServicePut$Plain.PATH, 'put');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CollectedServiceDetailDto>;
    })
  );
}

apiCollectedServicePut$Plain.PATH = '/api/CollectedService';
